<template>
  <div class="app-container">
    <table border="0" cellspacing="0" cellpadding="0">
      <tr>
        <th>用户名</th>
        <td>{{ msg.user_name }}</td>
        <th>订单编号</th>
        <td>{{ msg.order_sn }}</td>
        <th>下单时间</th>
        <td>{{ msg.create_time }}</td>
      </tr>
      <tr>
        <th>用户头像</th>
        <td>
          <el-image style="width: 100px; height: 100px" :src="msg.avatar" :preview-src-list="[msg.avatar]"> </el-image>
        </td>
        <th>课程名称</th>
        <td>{{ msg.course_title }}</td>
        <th>付款方式</th>
        <td>
          {{ ["", "支付宝", "微信", "对公打款", "线下支付", "免费"][msg.pay_type] }}
        </td>
      </tr>
      <tr>
        <th>手机</th>
        <td>{{ msg.mobile }}</td>
        <th>订单金额</th>
        <td>{{ msg.order_money }}</td>
      </tr>
    </table>

    <div class="menu-box">
      <h3 :class="sel === 1 ? 'sel' : ''" @click="sel = 1">课程目录</h3>
      <h3 :class="sel === 2 ? 'sel' : ''" @click="sel = 2">培训计划</h3>
      <h3 :class="sel === 3 ? 'sel' : ''" @click="sel = 3">培训记录</h3>
    </div>
    <el-collapse v-if="sel === 1" v-model="activeNames" @change="handleChange">
      <el-collapse-item v-for="(item, index) in msg.lession" :key="index" :title="item.level_name" name="1">
        <div v-for="(mi, ind) in item.child" :key="ind" class="course">
          <p>{{ ind }}、 {{ mi.name }}</p>

          <span>{{ ["", "线上", "线下"][mi.class_model] }}</span>
          <span v-if="mi.class_model == 1">
            <el-popover placement="top-start" title="视频" width="400" trigger="hover">
              <video :src="mi.vedio" controls="controls" width="350px"></video>
              <i slot="reference" class="el-icon-zoom-in">观看线上视频</i>
            </el-popover>
            观看时长：{{ formatSeconds(mi.play_time) }} /
            {{ times[index][ind] }}
          </span>
          <span v-else>
            <el-popover placement="top-start" title="上课时间" width="200" trigger="hover">
              <p v-if="mi.class_info">
                {{
                  JSON.parse(mi.class_info)
                    .map((it) => {
                      return "地点：" + it.lession_address + "  时间：" + it.lession_time;
                    })
                    .join(",")
                }}
              </p>
              <i slot="reference" class="el-icon-zoom-in">查看上课时间</i>
            </el-popover>
          </span>
        </div>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-if="sel === 2" v-model="activeNames" @change="handleChange">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>培训计划</span>

          <a
            href="javascript:void(0)"
            target="_blank"
            style="float: right; margin-left: 30px; width: 80px; height: 34px; line-height: 34px; font-size: 12px"
            size="small"
            type="text"
            @click="downloadPDF(msg.pdf_url)"
            >下载计划</a
          >
          <el-upload
            style="width: 100px; float: right; height: 34px"
            class="upload-demo"
            name="file"
            :action="baseUrl"
            :on-error="upError"
            :show-file-list="false"
            :headers="header"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-button size="small" style="padding: 12px 0" type="text"
              ><div>
                {{ msg.pdf_url ? "调整计划" : "上传计划" }}
              </div></el-button
            >
          </el-upload>
        </div>
        <div class="text item">
          <embed :src="imageUrl + '#toolbar=0'" type="application/pdf" width="100%" height="600px" />
        </div>
      </el-card>
    </el-collapse>

    <el-collapse v-if="sel === 3" @change="handleChange">
      <el-collapse-item v-for="(item, index) in train_log" :key="index" :title="item.create_time" :name="index">
        <div class="course">
          <p>{{ item.file_name }}</p>
          <p>调整人：{{ item.up_user_name }}</p>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { courseOrderDetail, OrderTrainUp } from "@/api/order.js";
import fileUpload from "@/components/pub/fileUploadNormal.vue";
import utils from "@/jslibs/utils";
export default {
  components: {
    fileUpload,
  },
  data() {
    return {
      msg: {},
      times: [],
      activeNames: "",
      sel: 1,
      fileList: [],
      updata: {
        source: 50,
      },
      imgBase: process.env.VUE_APP_BASE_OSS,
      baseUrl: process.env.VUE_APP_BASE_API + "/v1/common/UploadFile",
      header: {
        "X-Access-Token": utils.getCookie("X-Access-Token") || "",
      },
      imageUrl: this.imgLink || "",
      train_log: [],
    };
  },
  mounted() {
    this.querys = this.$route.query;
    if (this.querys.order_id) {
      this.getDetail(this.querys.order_id);
    } else {
      this.$message.error("未识别的订单");
    }
  },
  methods: {
    downloadPDF(fileName) {
      const fileUrl = fileName; // 替换为实际的文件路径
      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          // 创建一个临时的URL对象
          const url = URL.createObjectURL(blob);
          // 创建一个隐藏的<a>标签，并设置其href属性为临时URL
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName; // 设置下载的文件名
          a.style.display = "none";
          // 将<a>标签添加到文档中，并模拟点击下载
          document.body.appendChild(a);
          a.click();
          // 下载完成后，移除<a>标签和临时URL对象
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("下载文件时出错:", error);
        });
    },
    upError() {
      this.$emit("endUpload");
      this.$message.error("上传失败");
    },
    handleAvatarSuccess(res, file) {
      if (!res) {
        this.$message.warning("格式错误");
        return false;
      }
      console.log(res);
      console.log(file);
      this.imageUrl = this.imgBase + res.result; // 服务器返回的图片地址
      console.log(this.imageUrl, "img");
      const data = {
        pdf_url: this.imageUrl,
        order_id: this.querys.order_id,
        file_name: file.name,
      };
      OrderTrainUp(data).then((r) => {
        console.log(r);
      });
    },
    beforeAvatarUpload(file) {
      this.$emit("startUpload");
    },
    async getTime(file) {
      const res = await this.getVideoDuration(file);
      this.times = res;
    },
    getVideoDuration(file) {
      var url = file;
      var audioElement = new Audio(url);
      return new Promise(function (resolve, reject) {
        // ...some code
        audioElement.addEventListener("loadedmetadata", function () {
          // 视频时长值的获取要等到这个匿名函数执行完毕才产生
          const res = audioElement.duration; // 得到时长为秒，小数，182.36
          resolve(res);
          // self.ruleForm.videoDuration = parseInt(result); // 转为int值
        });
      });
    },
    //  秒数转化为时分秒
    formatSeconds(value) {
      //  秒
      let second = parseInt(value);
      //  分
      let minute = 0;
      //  小时
      let hour = 0;
      //  天
      //  let day = 0
      //  如果秒数大于60，将秒数转换成整数
      if (second > 60) {
        //  获取分钟，除以60取整数，得到整数分钟
        minute = parseInt(second / 60);
        //  获取秒数，秒数取佘，得到整数秒数
        second = parseInt(second % 60);
        //  如果分钟大于60，将分钟转换成小时
        if (minute > 60) {
          //  获取小时，获取分钟除以60，得到整数小时
          hour = parseInt(minute / 60);
          //  获取小时后取佘的分，获取分钟除以60取佘的分
          minute = parseInt(minute % 60);
          //  如果小时大于24，将小时转换成天
          //  if (hour > 23) {
          //    //  获取天数，获取小时除以24，得到整天数
          //    day = parseInt(hour / 24)
          //    //  获取天数后取余的小时，获取小时除以24取余的小时
          //    hour = parseInt(hour % 24)
          //  }
        }
      }

      let result = "" + parseInt(second);
      if (minute > 0) {
        result = "" + parseInt(minute) + ":" + result;
      }
      if (hour > 0) {
        result = "" + parseInt(hour) + ":" + result;
      }
      //  if (day > 0) {
      //    result = '' + parseInt(day) + '天' + result
      //  }
      console.log("result：", result);
      return result;
    },
    handleChange(val) {
      console.log(val);
    },
    async getDetail(id) {
      const res = await courseOrderDetail(id);
      const that = this;
      if (res) {
        this.msg = res;
        this.imageUrl = res.pdf_url;
        this.train_log = res.order_train;
        const arr = [];
        res.lession.forEach((item, index) => {
          arr[index] = [];
          item.child.forEach((t, i) => {
            if (t.class_model == 1) {
              that.getVideoDuration(t.vedio).then((e) => {
                arr[index][i] = that.formatSeconds(e);
              });
            } else {
              arr[index][i] = "";
            }
          });
        });
        this.times = arr;
        console.log(arr, "---");
      } else {
        this.msg = this.$route.query;
      }
      console.log(res);
    },
  },
};
</script>
<style>
.menu-box2 {
  width: 80%;
  margin-left: 10%;
  display: flex;
  flex-direction: row;
}
.menu-box2 .left {
  flex: 8;
}
.menu-box2 .right {
  flex: 2;
}
.menu-box {
  display: flex;
  height: 80px;
  line-height: 60px;
  flex-direction: row;
  color: #a5a5a5;
}
.sel {
  color: #333333;
}
.menu-box h3 {
  margin: 0 20px;
  border-bottom: 0;
  padding-top: 20px;
}
.el-collapse-item__header {
  background-color: #f5f5f5;
  text-indent: 10px;
}
</style>
<style scoped="scoped" lang="less">
table {
  width: 100%;
}
h3 {
  line-height: 60px;
  //border-bottom: 1px solid #bbb;
}
.course {
  padding: 10px 20px;
  display: flex;
  p {
    width: 50%;
  }
  span {
    color: #999;
    width: 10%;
  }
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}
</style>
